import type {Translation} from '@/utils/translation'
import type {useToastStore} from '../stores/toast'

type ToastStore = ReturnType<typeof useToastStore>

export function addDefaultErrorToast(toastStore: ToastStore, t: Translation, error: unknown) {
  console.error(error)
  toastStore.addErrorToast(t('alert.title.error'), t('alert.message.error'))
}

export function addDefaultSuccessToast(toastStore: ToastStore, t: Translation) {
  toastStore.addSuccessToast(t('alert.title.success'), t('alert.message.success'))
}

export const defaultErrorToastHandler = (toastStore: ToastStore, t: Translation) => (error: unknown) =>
  addDefaultErrorToast(toastStore, t, error)
export const defaultSuccessToastHandler = (toastStore: ToastStore, t: Translation) => () => addDefaultSuccessToast(toastStore, t)
